import { FilterByDate } from '../types/FilterByDate';

export const DateMap = {
  fromDateFilter: (filterByDate: FilterByDate): number => {
    switch (filterByDate) {
      case FilterByDate.TODAY:
        return 0;
      case FilterByDate.LAST_7_DAYS:
        return 6;
      case FilterByDate.LAST_30_DAYS:
        return 29;
      default:
        return 0;
    }
  },
};
